<template>
	<div class="page home">
		<transition name="fade" mode="out-in" appear>
			<section id="home-links" class="list">
				<router-link :to="{name: 'yarn-count-converter'}" class="list-link">
					<div class="container">
						<div class="content">
							<div class="list-link-inner">
								<div class="element">
									<svg class="list-link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M50 100a50 50 0 1 1 50-50 50.06 50.06 0 0 1-50 50zm0-96a46 46 0 1 0 46 46A46.05 46.05 0 0 0 50 4zm42 48H56v-4h31.95a38 38 0 0 0-75.9 0H44v4H8v-2a42 42 0 0 1 84 0z"/><path d="M50 58a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm21 38H29a2 2 0 0 1-2-2V64a2 2 0 0 1 2-2h42a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2zm-40-4h38V66H31zm19-62a2 2 0 0 1-2-2v-6a2 2 0 0 1 4 0v6a2 2 0 0 1-2 2zM26 28a2 2 0 0 1-1.41-.59l-4.3-4.28a2 2 0 0 1 2.83-2.83l4.24 4.24A2 2 0 0 1 26 28z"/><path d="M74 28a2 2 0 0 1-1.41-3.41l4.24-4.24a2 2 0 0 1 2.83 2.83l-4.24 4.24A2 2 0 0 1 74 28zM56 50a2 2 0 0 1-1.93-1.47L50 33.6l-4.07 14.93a2 2 0 0 1-3.86-1.05l6-22a2 2 0 0 1 3.86 0l6 22A2 2 0 0 1 56 50z"/></svg>
									{{$t('yarn-count-converter')}}
								</div>
							</div>
						</div>
					</div>
				</router-link>
				<router-link :to="{name: 'calculations'}" class="list-link">
					<div class="container">
						<div class="content">
							<div class="list-link-inner">
								<div class="element">
									<svg class="list-link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 65 100"><path d="M32.5 100C14.58 100 0 85.2 0 67s14.58-33 32.5-33a32.14 32.14 0 0 1 5.63.49V0H65v66.26q0 .4 0 .77C65 85.2 50.42 100 32.5 100zm0-61.94C16.8 38.06 4 51.06 4 67s12.8 29 28.5 29S61 83 61 67 48.2 38.06 32.5 38.06zm9.63-2.52A32.77 32.77 0 0 1 61 51.2V36.52h-7.15v-4H61v-3.75H47v-4h14V21h-7.15v-4H61v-3.7H47v-4h14V4H42.13zM32.5 93a26 26 0 0 1 0-52 26 26 0 0 1 0 52zm0-48a22 22 0 0 0 0 44 22 22 0 0 0 0-44zm0 41a19 19 0 1 1 18.77-19A18.93 18.93 0 0 1 32.5 86.06zm0-34a15 15 0 1 0 14.77 15A14.92 14.92 0 0 0 32.5 52z"/><path d="M27.16 63.58a2 2 0 0 1-2-2v-3.06c0-7.7 6.3-9.74 9.62-9.74h2.73a2 2 0 0 1 0 4H34.8a5.39 5.39 0 0 0-5.62 5.74v3.07a2 2 0 0 1-2.01 1.99z"/></svg>
									{{$t('calculations')}}
								</div>
							</div>
						</div>
					</div>
				</router-link>
				<router-link :to="{name: 'yarn-creation'}" class="list-link">
					<div class="container">
						<div class="content">
							<div class="list-link-inner">
								<div class="element">
									<svg class="list-link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 67 100"><path d="M44.4 10h-22a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h22a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-20-4h18V4h-18zm27 94h-36a2 2 0 0 1-2-2v-6a2 2 0 0 1 2-2h36a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2zm-34-4h32v-2h-32z"/><path d="M57.9 94H9.1a9 9 0 0 1-9-9.85l6.45-67.3A12 12 0 0 1 18.5 6H50a12 12 0 0 1 12 11.15l4.8 67.2a9 9 0 0 1-9 9.64zM18.5 10a8 8 0 0 0-8 7.24l-6.37 67.3a5 5 0 0 0 5 5.47H57.9a5 5 0 0 0 5-5.36l-4.8-67.2a8 8 0 0 0-8-7.43z"/><path d="M60.2 24.85A17 17 0 0 1 45.41 8h4a13 13 0 0 0 11.32 12.89zM61.1 35A27 27 0 0 1 35.41 8h4a23 23 0 0 0 21.88 23zm.8 10A37.13 37.13 0 0 1 25.41 8h4a33.12 33.12 0 0 0 32.53 33zm.74 10h-.2a47.06 47.06 0 0 1-47-46.94h4a43.06 43.06 0 0 0 43 42.94h.2zm-.2 10a57 57 0 0 1-56-46.14l3.93-.76a53 53 0 0 0 52 42.9h.86l.13 4zm0 10A67.27 67.27 0 0 1 4.56 41.81l3.45-2A63.25 63.25 0 0 0 62.41 71H64l.07 4z"/><path d="M4.53 63.86L4 60a12.9 12.9 0 0 0 10.11-7.3l3.6 1.72a16.88 16.88 0 0 1-13.19 9.54zM3.4 74l-.14-4A22.92 22.92 0 0 0 22 59.12l3.4 2.1A26.91 26.91 0 0 1 3.39 74zM2.4 84v-4a32.84 32.84 0 0 0 28-15.55l3.4 2.12A36.82 36.82 0 0 1 2.41 84zm5.05 9.73l-.42-4a43.14 43.14 0 0 0 32.61-21.22l3.46 2A47.15 47.15 0 0 1 7.46 93.73zm27.72-.1l-2.3-3.27A53.26 53.26 0 0 0 49.6 71.16L53.16 73a57.27 57.27 0 0 1-17.98 20.64zm26.55-25.06v-.01h4l-4 .01zm-11 24.8l-2.88-2.77a62.57 62.57 0 0 0 12.31-18.43l3.67 1.6a66.55 66.55 0 0 1-13.1 19.6z"/></svg>
									{{$t('yarn-creation')}}
								</div>
								<div class="element">
									<router-link :to="{name: 'yarns'}">
										<svg class="list-link-icon link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 3H5C3.88 3 3 3.9 3 5V19a1.99 1.99 0 0 0 1.99 2h14c1.1 0 2-.9 2-2V5a2 2 0 0 0-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H5V5h14v10z"/></svg>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</router-link>
			</section>
		</transition>
		<transition name="customer-area" mode="out-in" appear>
			<section id="customer-area">
				<span class="title">{{$t('customers-area')}}</span>
				<div id="customer-area-buttons">
					<router-link :to="{name: 'remote-control-machines'}" class="customer-area-button" id="remote-control">
						<div class="container">
							<div class="content">
								<div class="customer-area-button-inner">
									<svg class="customer-area-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M88,82H12A12,12,0,0,1,0,70V12A12,12,0,0,1,12,0H88a12,12,0,0,1,12,12V70A12,12,0,0,1,88,82ZM12,4a8,8,0,0,0-8,8V70a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8V12a8,8,0,0,0-8-8Z"/><path d="M0 62h96v4H0zm48 18h4v20h-4z"/><path d="M70 100H30a2 2 0 0 1 0-4h40a2 2 0 0 1 0 4zM50 48a2 2 0 0 1-1.41-.59 1.41 1.41 0 0 1-.25-.3 2.28 2.28 0 0 1-.19-.34 2.66 2.66 0 0 1-.11-.38 1.92 1.92 0 0 1 0-.78 2.22 2.22 0 0 1 .11-.37 2 2 0 0 1 .19-.35 1.41 1.41 0 0 1 .25-.3 2.06 2.06 0 0 1 2.83 0 1.75 1.75 0 0 1 .24.3 1.48 1.48 0 0 1 .19.35 1.57 1.57 0 0 1 .11.37 1.92 1.92 0 0 1 0 .78 1.8 1.8 0 0 1-.11.38 1.63 1.63 0 0 1-.19.34 1.75 1.75 0 0 1-.24.3A2 2 0 0 1 50 48zm10-10a2 2 0 0 1-1.41-.59 12 12 0 0 0-17 0 2 2 0 0 1-2.83-2.83 16 16 0 0 1 22.63 0 2 2 0 0 1-1.39 3.42zm8.48-8.48A2 2 0 0 1 67 29a24 24 0 0 0-34 0 2 2 0 1 1-2.8-2.8 28 28 0 0 1 39.6 0 2 2 0 0 1-1.41 3.41z"/></svg>
									{{$t('remote-control')}}
								</div>
							</div>
						</div>
					</router-link>
					<router-link :to="{name: 'production-control'}" class="customer-area-button">
						<div class="container">
							<div class="content">
								<div class="customer-area-button-inner">
									<svg class="customer-area-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path d="M88 100H12A12 12 0 0 1 0 88V12A12 12 0 0 1 12 0h76a12 12 0 0 1 12 12v76a12 12 0 0 1-12 12zM12 4a8 8 0 0 0-8 8v76a8 8 0 0 0 8 8h76a8 8 0 0 0 8-8V12a8 8 0 0 0-8-8zm38 78a2 2 0 0 1-2-2V38a2 2 0 0 1 4 0v42a2 2 0 0 1-2 2zm-24 0a2 2 0 0 1-2-2V70a2 2 0 0 1 4 0v10a2 2 0 0 1-2 2zm0-34a2 2 0 0 1-2-2V20a2 2 0 0 1 4 0v26a2 2 0 0 1-2 2zm48 16a2 2 0 0 1-2-2V20a2 2 0 0 1 4 0v42a2 2 0 0 1-2 2zm-48 2a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm24-20a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4zm24 60a8 8 0 1 1 8-8 8 8 0 0 1-8 8zm0-12a4 4 0 1 0 4 4 4 4 0 0 0-4-4z"/></svg>
									{{$t('production-control')}}
								</div>
							</div>
						</div>
					</router-link>
					<router-link :to="{name: 'machines-documents'}" class="customer-area-button">
						<div class="container">
							<div class="content">
								<div class="customer-area-button-inner">
									<svg class="customer-area-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 100"><path d="M60 92a2 2 0 0 1-1-.29L56 90a28 28 0 0 0-14.41-4H10a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h40a12 12 0 0 1 12 12v78a2 2 0 0 1-2 2zM12 82h29.7A32 32 0 0 1 58 86.47V12a8 8 0 0 0-8-8H12z"/><path d="M60 92a2 2 0 0 1-2-2V12A12 12 0 0 1 70 0h40a2 2 0 0 1 2 2v82a2 2 0 0 1-2 2H78.3a28 28 0 0 0-14.41 4l-3 1.7a2 2 0 0 1-1 .29zM70 4a8 8 0 0 0-8 8v74.47A32 32 0 0 1 78.31 82H108V4z"/><path d="M60 100a2 2 0 0 1-2-2v-8a2 2 0 0 1 4 0v4.47A32 32 0 0 1 78.31 90H116V12h-6a2 2 0 0 1 0-4h8a2 2 0 0 1 2 2v82a2 2 0 0 1-2 2H78.3a28 28 0 0 0-14.41 4l-3 1.7a2 2 0 0 1-1 .29z"/><path d="M60 100a2 2 0 0 1-1-.29L56 98a28 28 0 0 0-14.41-4H2a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h8a2 2 0 0 1 0 4H4v78h37.7A32 32 0 0 1 58 94.47V90a2 2 0 0 1 4 0v8a2 2 0 0 1-2 2zm42-82H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 14H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 14H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H88a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zM52 18H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 14H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 14H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm0 8H38a2 2 0 0 1 0-4h14a2 2 0 0 1 0 4zm16-44a2 2 0 0 1-1.41-3.41l8-8a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 68 26z"/><path d="M76 26a2 2 0 0 1-1.41-.59l-8-8a2 2 0 0 1 2.83-2.83l8 8A2 2 0 0 1 76 26zm-8 22a2 2 0 0 1-1.41-3.41l8-8a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 68 48z"/><path d="M76 48a2 2 0 0 1-1.41-.59l-8-8a2 2 0 0 1 2.83-2.83l8 8A2 2 0 0 1 76 48zm-8 22a2 2 0 0 1-1.41-3.41l8-8a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 68 70z"/><path d="M76 70a2 2 0 0 1-1.41-.59l-8-8a2 2 0 0 1 2.83-2.83l8 8A2 2 0 0 1 76 70zm-54 0a2 2 0 0 1-1.41-.59l-4-4a2 2 0 0 1 2.83-2.83l2.58 2.6 6.6-6.6a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 22 70zm0-44a2 2 0 0 1-1.41-.59l-4-4a2 2 0 0 1 2.83-2.83l2.58 2.6 6.6-6.6a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 22 26zm0 22a2 2 0 0 1-1.41-.59l-4-4a2 2 0 0 1 2.83-2.83l2.58 2.6 6.6-6.6a2 2 0 0 1 2.83 2.83l-8 8A2 2 0 0 1 22 48z"/></svg>
									{{$t('machines-documents')}}
								</div>
							</div>
						</div>
					</router-link>
				</div>
			</section>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'Home',
	methods: {
		doVibrate() {
			// Do vibration if available
			if (navigator.vibrate){
				// S.O.S in Morse ;)
				navigator.vibrate([100,30,100,30,100,200,200,30,200,30,200,200,100,30,100,30,100]);
			}
		}
	}
}
</script>

<style>
#home-links {
	display: flex;
	flex-direction: column;
	flex-grow: 1;
	margin-bottom: 1.6rem;
}

#home-links .list-link {
	display: flex;
	margin-top: .8rem;
	padding: .4rem 0;
	background-color: var(--primary_color);
	color: var(--inverse_text_color);
	font-size: 2.4rem;
	line-height: 2.0rem;
	align-items: center;
	flex-grow: 1;
	max-height: 7.2rem;
	min-height: 4.0rem;
}

#home-links .list-link-icon {
	display: block;
	flex-shrink: 0;
	width: 4.0rem;
	height: 4.0rem;
	margin-right: 1.6rem;
}

#home-links .list-link-icon path {
	fill: var(--inverse_text_color);
}

#customer-area .title {
	display: block;
	text-align: center;
	font-size: 1.8rem;
	color: #000;
}

#customer-area-buttons {
	display: flex;
	justify-content: space-between;
}

#customer-area-buttons .customer-area-button {
	display: flex;
	width: calc((100% - 1.6rem) / 3);
	background: var(--secondary_color); /*var(--primary_color);*/
	color: var(--inverse_text_color);
	text-align: center;
	padding: 1.6rem 0;
	cursor: pointer;

}

#customer-area-buttons .customer-area-button.disabled {
	background: var(--secondary_color);
	pointer-events: none;
}

#customer-area-buttons .customer-area-button .customer-area-button-inner {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}

#customer-area-buttons .customer-area-button-icon {
	display: block;
	flex-shrink: 0;
	width: 4.0rem;
	height: 4.0rem;
	margin-bottom: 1.6rem;
}

#customer-area-buttons .customer-area-button-icon path {
	fill: var(--inverse_text_color);
}
</style>